<template>
  <div v-if="store" id="profileTab">
    <b-row>
      <b-col md="4">
        <b-card no-body class="mt-3">
          <b-card-header>
            <span v-label-key="'ABOUT'">About</span>
          </b-card-header>
          <b-list-group>
            <b-list-group-item>
              <h5 v-label-key="'STORE_LOGIN_USERNAME'">Store Login Username</h5>
              <p>{{ store.username ? store.username : store.id }}</p>
            </b-list-group-item>
            <b-list-group-item>
              <h5 v-label-key="'STORE_ACTIVE'">Active</h5>
              <p>{{ store.active ? 'Yes' : 'No' }}</p>
            </b-list-group-item>
            <b-list-group-item>
              <h5 v-label-key="'NOTIFICATION_EMAIL'">Notification Email</h5>
              <p>{{ store.notification_email }}</p>
            </b-list-group-item>
            <b-list-group-item>
              <h5 v-label-key="'STORE_CONTACT_NUMBER'">Contact Number</h5>
              <p>{{ store.contact_number }}</p>
            </b-list-group-item>
            <b-list-group-item>
              <h5 v-label-key="'OPENING_HOURS'">Opening Hours</h5>
              <p>{{ store.opening_hours }}</p>
            </b-list-group-item>
            <b-list-group-item>
              <h5 v-label-key="'CREATED'">Created</h5>
              <p>{{ store.created | moment('YYYY-MM-DD') }}</p>
            </b-list-group-item>
            <!-- <div class="list-group-item">
                            <h5>Four Seasons Films Available</h5>
                            <p>{{store.fsfilms_available || 0}}</p>
                        </div> -->
            <b-list-group-item>
              <h5 v-label-key="'STORE_BYPASS_CREDITS'">Bypass Credits</h5>
              <p>{{ store.credits_available }}</p>
            </b-list-group-item>
            <b-list-group-item>
              <h5 v-label-key="'CHAIN'">Chain</h5>
              <p>{{ store.chain_name }}</p>
            </b-list-group-item>
            <b-list-group-item
              ng-if="store.subdistributor_id && auth.user.selectedAccess.roleLevel > 1"
            >
              <h5 v-label-key="'SUBDISTRIBUTOR'">Subdistributor</h5>
              <p>{{ store.distributor_name }}</p>
            </b-list-group-item>
            <b-list-group-item ng-if="auth.user.selectedAccess.roleLevel > 2">
              <h5 v-label-key="'DISTRIBUTOR'">Distributor</h5>
              <p>{{ store.distributor_name }}</p>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>

      <b-col md="4">
        <b-card no-body class="mt-3" v-if="store.enable_register_fourseasons">
          <b-card-header>
            <span v-label-key="'STORE_MANAGER_CODE'">Manager Code</span>
          </b-card-header>
          <div class="text-center">
            <img
              :src="'https://api.gokaizen.com/qr/' + store.manager_qr"
              alt=""
            />
          </div>
        </b-card>

        <b-card no-body class="mt-3" v-if="store.enable_register_fourseasons">
          <b-card-header>
            <span v-label-key="'STORE_FOUR_SEASONS_FILMS_AVAILABLE'"
              >Four Seasons Films Available</span
            >
          </b-card-header>
          <b-list-group>
            <div
              v-for="fsfilmtype in store.fsfilmtypes"
              :key="fsfilmtype.id"
              class="list-group-item"
              @click="editFSFilmTypeAvailability(fsfilmtype)"
            >
              {{ fsfilmtype.name }} ({{ fsfilmtype.count }})
            </div>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import $api from '@/services/api';

export default {
  name: 'StoreAboutTab',

  data() {
    return {
      store: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      $api.get(`/v1/dashboard/stores/${this.$route.params.id}`).then(store => {
        this.store = store;
      });
    },
    async editFSFilmTypeAvailability(type) {
      const promptLabel = this.$store.getters[
        'translations/getReplaceLabel'
      ]('STORE_UPDATE_FOUR_SEASON_FILM_COUNT_QUESTION', {
        '{FOUR_SEASON_FILM_NAME}': type.name,
      });
      const newCount = prompt(promptLabel, type.count); // eslint-disable-line no-alert
      if (!!newCount && !isNaN(newCount * 1)) {
        // eslint-disable-line no-restricted-globals
        type.count = newCount;
        await $api.put(
          `/v1/dashboard/stores/${this.store.id}/fsfilmtypes/${type.id}`,
          {
            count: newCount,
          }
        );
      }
    },
  },
};
</script>
